import { render, staticRenderFns } from "./identify_open.vue?vue&type=template&id=1d2ebc1f&scoped=true&"
import script from "./identify_open.vue?vue&type=script&lang=js&"
export * from "./identify_open.vue?vue&type=script&lang=js&"
import style0 from "./identify_open.vue?vue&type=style&index=0&id=1d2ebc1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ebc1f",
  null
  
)

export default component.exports